import React from 'react'
import type { SvgIconProps } from '@material-ui/core/SvgIcon'
import SvgIcon from '@material-ui/core/SvgIcon'

// Grid-of-panels — the "Surface View" toggle icon. Fill-based, inheriting the button's text color
// via currentColor.
const SurfaceViewIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox={'0 0 16 16'} {...props}>
    <svg width={16} height={16} viewBox={'0 0 16 16'} fill="none">
      <path
        d="M14 3.125H2C1.90054 3.125 1.80516 3.16451 1.73483 3.23483C1.66451 3.30516 1.625 3.40054 1.625 3.5V12.5C1.625 12.5995 1.66451 12.6948 1.73483 12.7652C1.80516 12.8355 1.90054 12.875 2 12.875H14C14.0995 12.875 14.1948 12.8355 14.2652 12.7652C14.3355 12.6948 14.375 12.5995 14.375 12.5V3.5C14.375 3.40054 14.3355 3.30516 14.2652 3.23483C14.1948 3.16451 14.0995 3.125 14 3.125ZM5.375 9.125V6.875H10.625V9.125H5.375ZM2.375 9.125V6.875H4.625V9.125H2.375ZM11.375 6.875H13.625V9.125H11.375V6.875ZM13.625 6.125H8.375V3.875H13.625V6.125ZM7.625 3.875V6.125H2.375V3.875H7.625ZM2.375 9.875H7.625V12.125H2.375V9.875ZM8.375 12.125V9.875H13.625V12.125H8.375Z"
        fill="currentColor"
      />
    </svg>
  </SvgIcon>
)
export default SurfaceViewIcon
